<template>
  <div class="weeks">
    <va-card :title="$t('weeksPoints.cards.title') + this.week">
      <va-data-table
        :fields="fields"
        :data="distribute_points"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'Points',
  props: {
    week: {
      required: true,
    },
  },
  data () {
    return {
      distribute_points: [],
    }
  },
  apollo: {
    distribute_points: {
      query: gql`
      query MyQuery($week: Int!) {
        distribute_points(args: {_week_id: $week}) {
          client_id
          points
          client {
            fullName
          }
        }
      }
      `,
      variables () {
        return {
          week: this.week,
        }
      },
    },

  },
  computed: {
    fields () {
      return [
        {
          name: 'client_id',
          title: this.$t('weeksRanking.headings.id'),
        },
        {
          name: 'client.fullName',
          title: this.$t('weeksRanking.headings.name'),
        },
        {
          name: 'points',
          title: this.$t('weeksPoints.headings.points'),
        },
      ]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('distribute_points')) {
      this.$apollo.queries.distribute_points.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
